import styled from "styled-components";

const FooterStyleWrapper = styled.footer`
  padding-top: 10px;  
  position: relative;
`;

export default FooterStyleWrapper;
